import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ENTERTAINMENT_LIST, ENTERTAINMENT_CHANGE_STATUS, ENTERTAINMENT_ADDEDIT, ENTERTAINMENT_DELETE, ENTERTAINMENT_GETONE, ENTERTAINMENT_IMAGE_UPLOAD } from "../../api/constApi";
import { entertainmentListApi, entertainmentChangeStatusApi, AddEditEntertainmentApi, DeleteEntertainmentApi, getOneEntertainmentApi, entertainmentImageUploadApi } from "../Services/entertainmentService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const entertainmentList = createAsyncThunk(ENTERTAINMENT_LIST, async (payload) => {
    const response = await entertainmentListApi(payload);
    return response.data;
});

export const entartianmentChangeStatus = createAsyncThunk(ENTERTAINMENT_CHANGE_STATUS, async (payload) => {
    const response = await entertainmentChangeStatusApi(payload);
    return response.data;
});

export const addEditEntertainment = createAsyncThunk(ENTERTAINMENT_ADDEDIT, async (payload) => {
    const response = await AddEditEntertainmentApi(payload);
    return response.data;
});
export const deleteEntertainment = createAsyncThunk(ENTERTAINMENT_DELETE, async (payload) => {
    const response = await DeleteEntertainmentApi(payload);
    return response.data;
});

export const getOneEntertainment = createAsyncThunk(ENTERTAINMENT_GETONE, async (payload) => {
    const response = await getOneEntertainmentApi(payload);
    return response.data;
});

export const entertainmentImageUpload = createAsyncThunk(ENTERTAINMENT_IMAGE_UPLOAD, async (payload) => {
    const response = await entertainmentImageUploadApi(payload);
    return response.data;
});

export const entertainmentSlice = createSlice({
    name: "entertainment",
    initialState: {
        entertainment: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(entertainmentList.fulfilled, (state, action) => {
            state.entertainment = action?.payload;
        });
        builder.addCase(addEditEntertainment.fulfilled, (state, action) => {
            state.entertainment = action?.payload?.Data;
        });
    }
});

export default entertainmentSlice.reducer;

// entertainmentslist selector
export const selectentertainment = (state) => state?.entertainment?.entertainment;
export const useEntertainment = () => {
    const entertainment = useSelector(selectentertainment);

    return useMemo(() => entertainment, [entertainment]);
};